module.exports = __webpack_public_path__ + "static/media/memberpix2.c9748278.jpg";